var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admins-grid m3"},[_c('users-index',{ref:"usersIndex",attrs:{"isOPS":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }